<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header text-center">
        <h4>REPORTE DE PRECIOS DE PRODUCTOS</h4>
        <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="buscarExistencia()"
          class="form-horizontal form-material noprint"
          id="categoryform"
          novalidate
        >
          <button onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>
          <div class="form-row">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['producto']"
                [controlName]="'Producto'"
              >
                <label for="inputGroupSelect02">Producto</label>
                <ng-select
                  bindLabel="name"
                  placeholder="Selecionar Producto"
                  [searchable]="true"
                  (change)="getSelectedProduct($event)"
                  formControlName="producto"
                >
                  <ng-option>
                    Seleccionar todos
                  </ng-option>
                  <ng-option [value]="item" *ngFor="let item of products">
                    {{ item.nombre_producto }}
                  </ng-option>
                </ng-select>
              </app-form-error-wrapper>
            </div>
            <div class="col-xs-12 col-md-2 mt-4">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table
          class="table table-bordered table-condensed table-hover table-responsive-md"
        >
          <thead>
            <tr class="text-center">
              <th>#</th>
              <th class="text-left">Nombre del producto</th>
              <th>Unidad</th>
              <th *hasPermission="['administrador', 'almacen']">Costo</th>
              <th>Precio Venta</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of existencia; let i = index">
            <tr>
              <th scope="row" class="text-right">{{ i + 1 }}</th>
              <td
                *ngIf="
                  checkStatus(data.existencia, data.limite_a);
                  else statusAmarillo
                "
                class="table-success"
              >
                {{ data.nombre }}
              </td>
              <ng-template #statusAmarillo>
                <td
                  *ngIf="
                    checkStatus(data.existencia, data.limite_r);
                    else statusRojo
                  "
                  class="table-warning"
                >
                  {{ data.nombre }}
                </td>
              </ng-template>
              <ng-template #statusRojo>
                <td class="table-danger">{{ data.nombre }}</td>
              </ng-template>
              <td class="text-center">{{ data.unidad }}</td>
              <td
                class="text-right"
                *hasPermission="['administrador', 'almacen']"
              >
                {{ data.costo_compra | number: '1.2-2' }}
              </td>
              <td class="text-right">
                {{ data.precio_venta | number: '1.2-2' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
